const toNumber = value => (
  new Intl.NumberFormat().format(Number(value))
)

export default toNumber
